import React from "react";
import { connect } from "react-redux";
import { follow, unfollow, getUsersThunkCreator} from "../../Redux/users-reducer.ts";
import Users from "./Users.tsx";
import Preloader from "../common/Preloader/Preloader.jsx";
import { compose } from "redux";
import { getCurrentPage, getFollowingIsProgres, getIsFetching, getPageSize, getTotalUsersCount, getUsers } from "../../Redux/users-selectors.ts";
import { userType } from "../../Type/Type.js";
import { AppStateType } from "../../Redux/redux-store.ts";

type MapStatePropsType = {
    currentPage: number
    pageSize: number
    isFetching: boolean
    totalUsersCount: number
    users: Array<userType>
    followingIsProgres: Array<number>
}

type MapDispatchPropsType = {
    getUsersThunkCreator: (currentPage: number, pageSize: number) => void
    unfollow: (userId: number) => void
    follow: (userId: number) => void
    // followingProgres: (isFetching: boolean, userId: number) => void
}


type PropsType = MapStatePropsType & MapDispatchPropsType

class UsersAPIComponent extends React.Component<PropsType> {
    
    componentDidMount() {
        this.props.getUsersThunkCreator(this.props.currentPage, this.props.pageSize);
    }

    onPageChanged = (pageNumber: number) => {
        this.props.getUsersThunkCreator(pageNumber, this.props.pageSize);
    }

    render() {
        return <>
        {this.props.isFetching ? <Preloader /> : null}
        <Users totalUsersCount={this.props.totalUsersCount}
            pageSize={this.props.pageSize}
            users={this.props.users}
            currentPage={this.props.currentPage}
            unfollow={this.props.unfollow}
            follow={this.props.follow}
            onPageChanged={this.onPageChanged}
            followingIsProgres={this.props.followingIsProgres}/>
        </>
    }
}

let mapStateToProps = (state: AppStateType): MapStatePropsType => {
    return {
        users: getUsers(state),
        totalUsersCount: getTotalUsersCount(state),
        pageSize: getPageSize(state),
        currentPage: getCurrentPage(state),
        isFetching: getIsFetching(state),
        followingIsProgres: getFollowingIsProgres(state),
    }
}

export default compose(
    connect<MapStatePropsType, MapDispatchPropsType, AppStateType>(mapStateToProps, { follow, unfollow, getUsersThunkCreator}),
    // withNavigateConteiner
)(UsersAPIComponent)